import {
  Group,
  List,
  Stack,
  ThemeIcon,
  Title,
  Text,
  ActionIcon,
} from '@mantine/core';
import { FiChevronRight } from 'react-icons/fi';
import { StyledComponent } from './styles';
import { useBlockItem } from './use-block-item';
import { useStore } from '@/store';
import {
  StructureBlockIndex,
  useStructureBlocks,
} from '@morph-mapper/node-logic';

interface BlockItemProps {
  type: StructureBlockIndex;
}

export const BlockItem = ({ type }: BlockItemProps) => {
  const variant = useStore(({ config: c }) => c.getVariant());
  const { structureBlocks } = useStructureBlocks(variant);
  const { icon: Icon, title, description } = structureBlocks[type];
  const { handleCreate } = useBlockItem(type);

  return (
    <List.Item onClick={handleCreate}>
      <StyledComponent>
        <Group>
          <ThemeIcon size="xl">
            <Icon />
          </ThemeIcon>
          <Stack spacing={5}>
            <Title order={6}>{title}</Title>
            <Text size="xs" c="dimmed">
              {description}
            </Text>
          </Stack>
        </Group>
        <ActionIcon>
          <FiChevronRight />
        </ActionIcon>
      </StyledComponent>
    </List.Item>
  );
};
